export default function initPersonCards() {
    const cards = [].slice.call(document.querySelectorAll('.personCard'));
    cards.forEach(initPersonCard);
}

async function initPersonCard(card) {
    const personId = card.dataset.personId;
    const emailLink = card.querySelector('.personCard-email');

    if (!emailLink) {
        return;
    }

    const storageKey = `employee/${personId}/email`;
    const email = window.sessionStorage?.getItem(storageKey);

    if (email) {
        revealEmail(email);
    } else {
        emailLink.addEventListener('click', async event => {
            event.preventDefault();
            revealEmail(await fetchEmail());
        }, { once: true });
    }

    function revealEmail(email) {
        emailLink.href = 'mailto:' + email;
        emailLink.querySelector('.text').innerHTML = email;
    }

    async function fetchEmail() {
        const email = await fetch(`/wp-json/theme/v1/employee/${personId}`)
            .then(response => response.json())
            .then(data => data.email);
        window.sessionStorage?.setItem(storageKey, email);
        return email;
    }
}
